function isEdge() {
    let userAgent = navigator.userAgent;
    return userAgent.includes("Edg/") || userAgent.includes("Edge/");
}

export function maybeShowGCalHelp() {
    const helpShown = localStorage.getItem('gcal_help_dismissed') === "true";

    if (isEdge() && !helpShown) {
        setTimeout(function () {
            const ratingModal = document.getElementById('gcal_help_modal');
            ratingModal.classList.remove("hidden");
        }, 0.5);
    }
}

document.getElementById('gcal_help_close')?.addEventListener('click', function() {
    localStorage.setItem('gcal_help_dismissed', 'true');
    const gcalHelpModal = document.getElementById('gcal_help_modal');
    gcalHelpModal.classList.add("hidden");
});

